import * as i0 from '@angular/core';
import { inject, Pipe } from '@angular/core';
import { TUI_FIRST_DAY_OF_WEEK } from '@taiga-ui/core/tokens';
import { map } from 'rxjs';
function convertToSundayFirstWeekFormat(weekDaysNames) {
  const sundayIndex = weekDaysNames.length - 1;
  return [weekDaysNames[sundayIndex] || '', ...weekDaysNames.slice(0, sundayIndex)];
}
let TuiOrderWeekDaysPipe = /*#__PURE__*/(() => {
  class TuiOrderWeekDaysPipe {
    constructor() {
      this.firstDayOfWeekIndex = inject(TUI_FIRST_DAY_OF_WEEK);
    }
    transform(mondayFirstWeekDays$) {
      return mondayFirstWeekDays$.pipe(map(convertToSundayFirstWeekFormat), map(weekDays => [...weekDays.slice(this.firstDayOfWeekIndex), ...weekDays.slice(0, this.firstDayOfWeekIndex)]));
    }
    static {
      this.ɵfac = function TuiOrderWeekDaysPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TuiOrderWeekDaysPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "tuiOrderWeekDays",
        type: TuiOrderWeekDaysPipe,
        pure: true
      });
    }
  }
  return TuiOrderWeekDaysPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiOrderWeekDaysPipe };
